import React from 'react';
import ExpandableContainer from '../ExpandableContainer';
import * as Row from '../../../layout/Row';

export default class SummaryPrimarySideEquipment extends React.Component {


    render() {
        if (this.props.model.unitType.isCustomLogic.value || !this.props.model.primarySideEquipment)
            return (<React.Fragment></React.Fragment>)

        var data = [
            this.props.model.primarySideEquipment.heating1,
            this.props.model.primarySideEquipment.heating2,
            this.props.model.primarySideEquipment.heating3,
            this.props.model.primarySideEquipment.dhw
        ].filter(x => x !== undefined)

        var chunks = data.partition(2)
        return (
            <ExpandableContainer label={__('Primary side equipment')}>
                <Row.Container hasOuterGutter={false} className="pse-general">
                    <Row.Column6>
                        {this.renderGeneralInformation()}
                    </Row.Column6>
                </Row.Container>
                {chunks.map((circuits, idx) => (
                    <Row.Container key={idx} hasOuterGutter={false}
                                   className={circuits.length == 1 ? 'single-circuit' : ''}>
                        {circuits.map((c, idx) => (
                            <Row.Column6 key={idx}>{this.renderHeating(c.name.value, c)}</Row.Column6>
                        ))}
                    </Row.Container>
                ))}
                {this.showOtherComponents() && <Row.Container hasOuterGutter={false}>
                    <div className="column-5 column-xs-12">
                        <div className="configuration-editor-summary-pse-section" style={{marginTop: '2.5rem'}}>
                            <div>{__('Other components')}</div>
                            <div>
                                {this.renderSimpleField(this.props.model.primarySideEquipment.dhStrainer)}
                                {this.renderSimpleField(this.props.model.primarySideEquipment.pressureMetering)}
                                {this.renderSimpleField(this.props.model.primarySideEquipment.thermometerPrimarySupply)}
                                {this.renderSimpleField(this.props.model.primarySideEquipment.thermometerPrimaryReturn)}
                                {this.renderSimpleField(this.props.model.primarySideEquipment.dhFlowRetShutOff)}
                                {this.renderSimpleField(this.props.model.primarySideEquipment.primaryOutPipeEMS)}
                                {this.renderSimpleField(this.props.model.primarySideEquipment.energyMeter)}
                            </div>
                        </div>
                    </div>
                </Row.Container>}
            </ExpandableContainer>
        )
    }

    showOtherComponents() {
        return this.props.model.primarySideEquipment.dhStrainer.value
            || this.props.model.primarySideEquipment.pressureMetering.value
            || this.props.model.primarySideEquipment.thermometerPrimarySupply.value
            || this.props.model.primarySideEquipment.thermometerPrimaryReturn.value
            || this.props.model.primarySideEquipment.dhFlowRetShutOff.value
            || this.props.model.primarySideEquipment.primaryOutPipeEMS.value
            || this.props.model.primarySideEquipment.energyMeter.value;
    }


    renderGeneralInformation() {
        const pseModel = this.props.model.primarySideEquipment

        return (
            <div className="configuration-editor-summary-pse-section">
                <div>{__('Control valves')}</div>
                <div>
                    {this.renderSimpleField(pseModel.primaryMainPipeSize)}
                    {this.renderSimpleField(pseModel.controlValveManufacturer)}
                </div>
            </div>
        )
    }

    renderHeating(label, model) {
        const forLoop = (i, fn) => {
            let results = []
            for (let j = 0; j < i; j++) {
                results.push(fn(j))
            }
            return results
        }

        const hasCV = propertyName => model['cV1'] && model['cV1'][propertyName].visible

        return (
            <div className="configuration-editor-summary-pse-section" style={{marginTop: '2.5rem'}}>
                <div>{label}</div>
                {this.renderSimpleField(model.availableDP)}
                {this.renderSimpleField(model.neededKVS)}

                <div className="configuration-editor-summary-heating-section">
                    <div className="configuration-editor-summary-table-wrapper">
                        <table className="configuration-editor-summary-table-multi">
                            <thead>
                            <tr>
                                <th></th>
                                {forLoop(model.numberOfControlValves.value, idx => (
                                    <th key={idx} style={{textAlign: 'center'}}>{__('CV' + (idx + 1))}</th>))}
                                <th>{__('Unit')}</th>
                            </tr>
                            </thead>

                            <tbody>
                            {hasCV('controlValve') && <tr>
                                <td>{model[`cV1`].controlValve.label}
                                </td>
                                {forLoop(model.numberOfControlValves.value, idx => (<td key={idx}
                                                                                        align="center">{model[`cV${idx + 1}`] && this.getFieldValue(model[`cV${idx + 1}`].controlValve)}</td>))}
                                <td></td>
                            </tr>}
                            {hasCV('controlValvePICV') && <tr>
                                <td>{model[`cV1`].controlValvePICV.label}
                                </td>
                                {forLoop(model.numberOfControlValves.value, idx => (<td key={idx}
                                                                                        align="center">{model[`cV${idx + 1}`] && this.getFieldValue(model[`cV${idx + 1}`].controlValvePICV)}</td>))}
                                <td></td>
                            </tr>}
                            {hasCV('kvs') && <tr>
                                <td>{model[`cV1`].kvs.label}
                                </td>
                                {forLoop(model.numberOfControlValves.value, idx => (<td key={idx}
                                                                                        align="center">{model[`cV${idx + 1}`] && this.getFieldValue(model[`cV${idx + 1}`].kvs)}</td>))}
                                <td></td>
                            </tr>}
                            {hasCV('dn') && <tr>
                                <td>{model[`cV1`].dn.label}
                                </td>
                                {forLoop(model.numberOfControlValves.value, idx => (<td key={idx}
                                                                                        align="center">{model[`cV${idx + 1}`] && this.getFieldValue(model[`cV${idx + 1}`].dn)}</td>))}
                                <td></td>
                            </tr>}
                            <tr>
                                <td>{model.cvFlow.label}</td>
                                <td align="center"
                                    colSpan={model.numberOfControlValves.value}>{this.getFieldValue(model.cvFlow)}</td>
                                <td>{model.cvFlow.unit}</td>
                            </tr>
                            {model.totalKVS.visible && <tr>
                                <td>{model.totalKVS.label}</td>
                                <td align="center"
                                    colSpan={model.numberOfControlValves.value}>{this.getFieldValue(model.totalKVS)}</td>
                                <td></td>
                            </tr>}
                            {model.controlValvePressureDrop.visible && <tr>
                                <td>{model.controlValvePressureDrop.label}</td>
                                <td align="center"
                                    colSpan={model.numberOfControlValves.value}>{this.getFieldValue(model.controlValvePressureDrop)}</td>
                                <td>{model.controlValvePressureDrop.unit}</td>
                            </tr>}
                            {hasCV('actuatorType') && <tr>
                                <td>{model[`cV1`].actuatorType.label} </td>
                                {forLoop(model.numberOfControlValves.value, idx => (<td key={idx}
                                                                                        align="center">{model[`cV${idx + 1}`] && this.getFieldValue(model[`cV${idx + 1}`].actuatorType)}</td>))}
                                <td></td>
                            </tr>}
                            {hasCV('actuatorControlSignal') && <tr>
                                <td>{model[`cV1`].actuatorControlSignal.label} </td>
                                {forLoop(model.numberOfControlValves.value, idx => (<td key={idx}
                                                                                        align="center">{model[`cV${idx + 1}`] && this.getFieldValue(model[`cV${idx + 1}`].actuatorControlSignal)}</td>))}
                                <td></td>
                            </tr>}

                            </tbody>

                        </table>
                    </div>

                </div>
            </div>

        )
    }

    renderSimpleField(field) {
        if (typeof field.value === 'undefined' || field.value === null) {
            return <React.Fragment></React.Fragment>;
        }

        return (
            <div className="configuration-editor-summary-heating-field">
                <div>{field.label}</div>
                <div>{this.getFieldValue(field)} {field.unit}</div>
            </div>
        )
    }

    getFieldValue(field) {
        if (field.items) {
            let val = field.items.find(x => x.value === field.value)
            if (typeof val === 'object') {
                return val.text
            }
        }

        return field.value
    }
}